<template>
  <Modal
      ref="modal"
      :id="id"
      :modalTitle="modalTitle"
      :class="classes"
      hide-footer
      :onClose="onClose"
  >
    <NotificationContainer ref="notifier" />
    <form @submit.prevent="submitForm">
      <div class="row">
        <!-- Nombre -->
        <div class="col-12 mb-3">
          <label class="form-label">Nombre de la promoción</label>
          <input type="text" class="form-control" v-model="editedPromotion.name" required />
        </div>

        <!-- Descripción -->
        <div class="col-12 mb-3">
          <label class="form-label">Descripción</label>
          <textarea class="form-control" v-model="editedPromotion.description" rows="3"></textarea>
        </div>

        <!-- Condiciones legales -->
        <div class="col-12 mb-3">
          <label class="form-label">Condiciones legales</label>
          <textarea class="form-control" v-model="editedPromotion.legal_terms" rows="3"></textarea>
        </div>

        <!-- Fecha de inicio y fin -->
        <div class="col-lg-3 col-12 mb-3">
          <label class="form-label">Fecha de inicio</label>
          <input type="date" class="form-control" v-model="editedPromotion.start_date" required />
        </div>
        <div class="col-lg-3 col-12 mb-3">
          <label class="form-label">Fecha de fin</label>
          <input type="date" class="form-control" v-model="editedPromotion.end_date" required />
        </div>

        <!-- Límite de unidades -->
        <div class="col-lg-3 col-12 mb-3">
          <label class="form-label">Límite de unidades</label>
          <input type="number" class="form-control" v-model="editedPromotion.units_limit" required />
        </div>

        <!-- Prioridad -->
        <div class="col-lg-3 col-12 mb-3">
          <label class="form-label">Prioridad</label>
          <input type="number" class="form-control" v-model="editedPromotion.priority" required />
        </div>

        <!-- Estado -->
        <div class="col-lg-3 col-12 mb-3">
          <label class="form-label">Estado</label>
          <select class="form-control" v-model="editedPromotion.status" required>
            <option value="ACTIVATED">Activo</option>
            <option value="PENDING">Pendiente</option>
            <option value="DEACTIVATED">Desactivado</option>
            <option value="DELETED">Eliminado</option>
          </select>
        </div>

        <!-- Componente DropFile -->
        <div class="col-12" v-if="showDropFile">
          <DropFile
              :promotionId="editedPromotion.promotionId"
              @clientList="handleClientList"
          />
        </div>

        <!-- Botones -->
        <div class="col-12 d-flex justify-content-end mt-4">
          <button type="button" class="btn generalSecondaryButton me-2" @click="onClose" :disabled="loading">
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary generalPrimaryButton" :disabled="loading">
            <span v-if="loading">Guardando...</span>
            <span v-else>Guardar cambios</span>
          </button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>

import Modal from "../../../Shared/Modal.vue";
import DropFile from "./DropFile.vue";
import NotificationContainer from "../../../Promotions/PromotionsList/Notifications/NotificationContainer.vue";
import axios from "axios";

export default {
  name: "EditPromotionModal",
  props: {
    id: { type: String, required: true },
    modalTitle: { type: String, default: "Editar Promoción" },
    promotion: { type: Object, required: true },
  },
  data() {
    return {
      editedPromotion: { ...this.promotion },
      classes: "modal-xl",
      loading: false,
      newClientList: [],
    };
  },
  computed: {
    // Valida si se debe mostrar el componente DropFile
    showDropFile() {
      return (
          this.editedPromotion.customers &&
          Array.isArray(this.editedPromotion.customers.legal_identifier) &&
          this.editedPromotion.customers.legal_identifier.length > 0
      );
    },
  },
  watch: {
    // Observa cambios en la prop 'promotion'
    promotion: {
      immediate: true, // Ejecutar el watch cuando el componente se monta
      handler(newPromotion) {
        // Copia los datos de 'promotion' a 'editedPromotion'
        this.editedPromotion = { ...newPromotion };
      },
    },
  },
  components: {
    Modal,
    NotificationContainer,
    DropFile,
  },
  methods: {
    async submitForm() {
      this.loading = true;
      try {
        const updatedFields = this.preparePatchData();
        await axios.patch(`/promotions/promotion/${this.editedPromotion.promotionId}`, updatedFields);
        this.$refs.notifier.addNotification("success", "Guardado exitoso", "Los cambios se han guardado correctamente.");
        this.$emit("promotionUpdated", this.editedPromotion);
        setTimeout(() => {
          this.$emit("promotionUpdated", this.editedPromotion); // Emitir evento de éxito
          this.onClose(); // Cerrar el modal
        }, 2000);
      } catch (error) {
        console.error(error);
        this.$refs.notifier.addNotification("error", "Error al guardar", "No se pudieron guardar los cambios.");
      } finally {
        this.loading = false;
      }
    },
    preparePatchData() {
      const updatedFields = {};
      for (const key in this.editedPromotion) {
        if (this.editedPromotion[key] !== this.promotion[key]) {
          updatedFields[key] = this.editedPromotion[key];
        }
      }
      updatedFields.clientList = this.clientHandlingOption === "add"
          ? [...(this.promotion.clientList || []), ...this.newClientList]
          : this.newClientList;
      return updatedFields;
    },
    handleClientList(list) {
      this.newClientList = list;
    },

    show() {
      this.editedPromotion = { ...this.promotion };
      if (this.$refs.modal) this.$refs.modal.show();
    },
    hide() {
      if (this.$refs.modal) this.$refs.modal.hide();
    },
    onClose() {
      this.hide();
      this.$emit("closeModal");
    },
  },
};
</script>
